/**
 * Feature flag that gates the entire buyer Hub page (`/hub`).
 *
 * Resolved through the Athena BFF. During local development the page can be
 * force-enabled with:
 *   window.localStorage.setItem('opendoor.cosmos.buyer-hub-v1', 'true')
 */
export const HUB_FEATURE_FLAG = 'buyer-hub-v1';

export const HUB_FLAG_ENABLED = 'on';
